module.exports = __webpack_public_path__ + "img/iotx.3d21b905.svg";